import React, { useEffect } from "react";
import Table from "./Table";

const UjiSilangProvinsiSlidePositif = () => {
  useEffect(() => {
    document.title = "SISMAL | Uji Silang Provinsi";
  }, []);

  return (
    <div className="dashboard-wrapper">
      <Table />
    </div>
  );
};

export default UjiSilangProvinsiSlidePositif;
